<template>
  <div class="md:ps-30 md:pe-30">
    <div v-for="(section, index) in list" :key="index">
      <free-form
        v-if="section.sectionName === 'SectionFreeForm'"
        :title="section.title"
        :content-block="section.contentBlock"
        no-prefix
      />

      <div
        v-else-if="section.sectionName === 'SectionImage'"
        class="container mx-auto w-full md:px-10 px-6"
      >
        <ui-image class="max-h-full" :src="section.image" :lazy="true" />
      </div>
    </div>
  </div>
</template>
<script>
import { UiImage } from '~/components/atoms'
import { FreeForm } from '~/components/organisms'

export default {
  components: {
    FreeForm,
    UiImage,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
}
</script>
